import * as React from 'react';
import { Container } from '@grandvisionhq/elements';
import { StoreFinderProvider } from '@grandvisionhq/stores-v2';
import StoreFinder from '../StoreFinder/StoreFinderContainer.js';

const AppointmentLocation = ({ appointmentTypeId  })=>/*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        withUrlParams: true
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(StoreFinder, {
        appointmentTypeId: appointmentTypeId
    })))
;
var AppointmentLocation$1 = AppointmentLocation;

export { AppointmentLocation$1 as default };
//# sourceMappingURL=AppointmentLocation.js.map
